import React from 'react';
import { Chip, makeStyles } from '@material-ui/core';
import {
  lightGreen,
  grey,
  lightBlue,
  orange,
} from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

function ChipArray(props) {
  const classes = useStyles();
  // const chipData = [  {label: 'React'}, {label: 'NodeJS'}, {label: 'UI/UX'}, {label: 'React'}, {label: 'NodeJS'}, {label: 'UI/UX'} ];
  const chipData = props.techUsed;
  const chipArr = chipData.map((tech, ind) => {
    let labelLowerCase = tech.toLowerCase();
    let colorPicker, fontColor;
    switch (labelLowerCase) {
      case 'reactjs':
        colorPicker = lightBlue[500]
        break;
      case 'nodejs':
        colorPicker = lightGreen[500]
        break;
      case 'jquery':
        colorPicker = orange[500]
        break;
      case 'cypress':
        colorPicker = grey[500]
        fontColor = 'white'
        break;
      case 'postgresql':
        colorPicker = '#fdd835'
        break;
      case 'googlemaps':
        colorPicker = `#c6ff00`
        break;
      case 'wordpress':
        colorPicker = `#5e35b1`
        fontColor = 'white'
        break;
      case 'css':
        colorPicker = lightBlue[500]
        break;
      default:
        colorPicker = grey[700]
        fontColor = 'white'
        break;
    }
      return (
        <Chip
        style={{background: colorPicker, color: fontColor ? fontColor : 'black'}}
        key={ind}
        size='small' 
        label={tech}
        className={classes.chip}
      />
      )
  })
  return (
    <div>
      {chipArr}
    </div>
  );
}

export default ChipArray;